import { Pipe, PipeTransform } from '@angular/core';

import { STORAGE_UNIT_SIZE } from '../../app.constants';
import { StorageUnit } from '../../project-imports/local-imports/local-import.enum';

@Pipe({ name: 'storageUnit', pure: true })
export class StorageUnitPipe implements PipeTransform {
  public transform(bytes: number, fixed = 1): string {
    if (bytes < STORAGE_UNIT_SIZE || !bytes) {
      return `${bytes ?? 0} ${StorageUnit.Byte}`;
    }

    const sizeInKb = bytes / STORAGE_UNIT_SIZE;

    if (sizeInKb < STORAGE_UNIT_SIZE) {
      return `${sizeInKb.toFixed(fixed)} ${StorageUnit.Kilobyte}`;
    }

    const sizeInMb = sizeInKb / STORAGE_UNIT_SIZE;

    if (sizeInMb < STORAGE_UNIT_SIZE) {
      return `${sizeInMb.toFixed(fixed)} ${StorageUnit.Megabyte}`;
    }

    return `${(sizeInMb / STORAGE_UNIT_SIZE).toFixed(fixed)} ${StorageUnit.Gigabyte}`;
  }
}
